import { IonButton, IonPage, IonSpinner } from '@ionic/react';
import { useAddExperienceMutation } from '../api/UserApi';
import { GettingStartedSwiper } from '../components/GettingStartedSwiper';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { IconCheck } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { useGettingStartedPages } from '../hooks/useGettingStartedPages';
import { useGetPublicInformationQuery } from '../api/SiteSettingsAPI.js';
// eslint-disable-next-line css-modules/no-unused-class
export const GettingStartedExperience: React.FC<{ onDismiss: () => {} }> = ({ onDismiss }) => {
	const { data: siteSettings } = useGetPublicInformationQuery();
	const [addExperience] = useAddExperienceMutation();

	const addWelcomeMessageExperience = () => {
		onDismiss();
		addExperience({ experience: 'welcomeMessage' });
	};

	const { setSwiperInstance, currentImageIndex, handleSlideChange, handleClick, Pages } = useGettingStartedPages({
		siteSettings
	});
	return (
		<IonPage>
			{!siteSettings ? (
				<QuirkIonContent fullscreen={true}>
					<div className="center-align">
						<IonSpinner color="primary" />
					</div>
				</QuirkIonContent>
			) : (
				<>
					<Header
						title="logo"
						left={
							<IconButton
								testId="acceptGettingStarted"
								icon={<IconCheck />}
								label="Got it"
								onClick={addWelcomeMessageExperience}
							/>
						}
						right={
							<IonButton
								fill="solid"
								onClick={
									currentImageIndex < Pages.length - 1
										? () => handleClick(currentImageIndex + 1)
										: () => addWelcomeMessageExperience()
								}
								style={{ height: '35px' }}
							>
								{currentImageIndex < Pages.length - 1 ? 'Next' : 'Finish'}
							</IonButton>
						}
					/>
					<QuirkIonContent>
						<GettingStartedSwiper
							Pages={Pages}
							handleClick={handleClick}
							handleSlideChange={handleSlideChange}
							setSwiperInstance={setSwiperInstance}
							currentImageIndex={currentImageIndex}
						/>
					</QuirkIonContent>
				</>
			)}
		</IonPage>
	);
};
